"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenubar = void 0;
const react_1 = require("react");
const navigation_context_1 = require("../navigation/navigation-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const force_render_1 = require("../../utils/force-render");
function useMenubar(options) {
    const { navigate } = (0, react_1.useContext)(navigation_context_1.NavigationContext);
    const drawerTitleRef = (0, react_1.useRef)(null);
    const { forceRender } = (0, force_render_1.useForceRender)();
    const itemsRef = (0, react_1.useRef)(options.items);
    const handleLogoClick = (0, event_callback_hook_1.useEventCallback)(() => {
        navigate(options.logoUrl);
    });
    const modifyItems = (0, event_callback_hook_1.useEventCallback)((callback) => {
        const newItems = callback(itemsRef.current);
        itemsRef.current = newItems;
        forceRender();
    });
    const context = (0, react_1.useMemo)(() => ({
        handleLogoClick,
        modifyItems,
        drawerTitleRef,
    }), [handleLogoClick, modifyItems, drawerTitleRef]);
    return {
        handleLogoClick,
        context,
        items: itemsRef.current,
    };
}
exports.useMenubar = useMenubar;
//# sourceMappingURL=menubar-hook.js.map